import { SIZES_VALUE } from './constants';

export const expandSizeValues = (
  values: string
): string | number | undefined => {
  if (values.includes(' ')) {
    return values.replace(/\S+/g, (s) => {
      const size = SIZES_VALUE[s as keyof typeof SIZES_VALUE];
      return size !== undefined ? `${size}px` : '0';
    });
  }
  const size = SIZES_VALUE[values as keyof typeof SIZES_VALUE];
  return size !== undefined ? size : '0';
};
